// FETCH DATA
export const FETCH_BATTERY = "fetch_battery";
export const FETCH_BATTERY_SOH = "fetch_battery_soh";
export const FETCH_ASSET = "fetch_asset";
export const FETCH_PSATYPICAL = "fetch_ps_atypical";
export const FETCH_PSGENERIC = "fetch_ps_generic";
export const FETCH_CONTRACT = "fetch_contract";
export const FETCH_METER_WITH_BESS = "fetch_meter_with";
export const FETCH_METER_WITHOUT_BESS = "fetch_meter_without";
export const FETCH_STATUS = "fetch_status";
export const FETCH_STATUS_RANGE = "fetch_status_range";
export const FETCH_UNAVAILABILITIES = "fetch_unavailabilities";
export const FETCH_TARIFF = "fetch_tariff";
export const HANDLE_ERRORS = "handle_errors";
export const HANDLE_SUCCESS = "handle_success";
export const FILE_SAVED = "file_saved";
export const FETCH_BATTERY_TABLE = "fetch_battery_table";
// AUTH
export const LOGIN_IS_LOADING = "login_is_loading";
export const JWT_AUTH_SUCCESS = "jwt_auth_success";
export const LOGIN_OPERATOR_SUCCESS = "login_operator_success";
export const LOGIN_CUSTOMER_SUCCESS = "login_customer_success";
export const LOGIN_FAIL = "login_fail";
export const LOGOUT = "logout";
export const FETCH_PERMISSIONS = "fetch_permissions";
export const CHANGE_OP_PWD = "change_op_pwd";
export const CHANGE_CU_PWD = "change_cu_pwd";
//DATE RANGE
export const CHANGE_DATE_RANGE = "change_date_range";
//  MODE
export const TOGGLE_MODE = "toggle_mode";
export const LOADING_MODE = "loading_mode";
// TABLES
export const SORT_COLUMN = "sort_column";
export const UPDATE_DATA = "update_data";
export const FILTER_PS_DATA = "filter_ps_data";
export const UPDATE_DISPLAYED_DATA = "update_displayed_data";
export const CHANGE_TABLE_DATE_RANGE = "table_date_change_reducer";
export const SAVE_JSON = "save_json";
// PLOT
export const FETCH_CHART_DATA = "fetch_chart_data";
export const FETCH_SITE_DATA = "fetch_site_data";
export const UPDATE_CHART = "update_chart";
export const PLOT_LOAD_BESS = "plot_load_bess";
export const LATEST_DATA = "latest_data";
export const PLOT_LOAD_NO_BESS = "plot_load_no_bess";
export const PLOT_BATTERY_POWER = "plot_battery_power";
export const PLOT_PREF = "plot_pref";
export const PLOT_PMAX = "plot_pmax";



// WEBPACK FOOTER //
// ./src/actions/types.js